import axios from 'axios';

const suiviApi = axios.create({
  baseURL: 'https://affixe20-suiviutilisation.firebaseapp.com/api/v1/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export default suiviApi;



// WEBPACK FOOTER //
// ./src/api/suiviApi.js